import React, { useCallback, useEffect, useState } from "react"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { CardBody } from "../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { useTranslation } from "react-i18next"
import { EmptyCard, TableSkeleton, TableView } from "../../../../component/index.jsx"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { useDispatch, useSelector } from "react-redux"
import {
  formatterRowComponent,
  initialFilterTable
} from "../../../../component/atoms/Tabel/index.jsx"
import { stringFormatting } from "../../../helpers/TextHelper.js"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { Link, useHistory } from "react-router-dom"
import { useLocation } from "react-router"
import { DetailSvgIcon } from "../../../../component/atoms/Icons/SVG/index.jsx"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { getListRegionals } from "../../../../redux/actions/FieldOfficerAction.jsx"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"

export function ListOpsTeamRegionals() {
  const subheader = useSubheader()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { General, FieldOfficer } = useSelector((state) => state)
  const user = loadUserLogin()
  const history = useHistory()
  const location = useLocation()
  const privileges = loadUserLogin().privilege
  const [currentRegionalsParam] = useState({
    ...initialFilterTable
  })
  const fetchRegionalData = (param) => {
    return dispatch(getListRegionals(param))
  }
  useEffect(() => {
    subheader.setTitle(t("sub_header_ops_team"))
    if (!user?.regional_id) {
      subheader.setBreadcrumbs([
        {
          title: t("sub_header_ops_team")
        },
        {
          title: t("sub_header_all_area")
        }
      ])
    }
  }, [])
  useEffect(() => {
    const result = location?.search
    if (user?.regional_id) {
      history.push(RoutesConstants.FIELD_OFFICER.OPS_ADMIN_REGIONAL(user?.regional_id))
    } else {
      fetchRegionalData(result)
    }
  }, [location.search, user?.regional_id])

  const changeRegionalsPage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...currentRegionalsParam,
          ...param,
          sort: param.sortField + "," + param.sortOrder
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...currentRegionalsParam,
          ...param
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, currentRegionalsParam]
  )

  const columnRegionalProperties = [
    {
      text: t("label_regional_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-bolder"}>{stringFormatting(e?.regional_name)}</span>
            </div>
          </>
        )
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      text: t("label_regional_head_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span>{stringFormatting(e?.regional_head_name)}</span>
            </div>
          </>
        )
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      text: t("table_header_sub_regional_amount"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span>{stringFormatting(e?.total_sub_regional)}</span>
            </div>
          </>
        )
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      text: t("label_detail"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div>
            {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1 && (
              <Link to={RoutesConstants.FIELD_OFFICER.OPS_ADMIN_REGIONAL(e?.regional_id)}>
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">
                      Detail {stringFormatting(e?.regional_name)}
                    </Tooltip>
                  }>
                  <div className="btn btn-icon btn-detail btn-hover-secondary btn-md mx-3">
                    <DetailSvgIcon size="2x" />
                  </div>
                </OverlayTrigger>
              </Link>
            )}
          </div>
        )
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    }
  ]
  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mt-5 mb-4 position-relative">
          <h2 className={"font-weight-bolder mb-5"}>{t("label_ops_team_regional")}</h2>
        </div>
        <Card className="mt-4">
          <CardBody>
            {General?.loading ? (
              <TableSkeleton column={5} row={10} />
            ) : (FieldOfficer?.pageData ?? []).length === 0 ? (
              <EmptyCard
                image={ILLUSTRATION_CONSTANTS.EMPTY_STATE}
                body={t("messages_response_empty_state", { name: "Regional" })}
              />
            ) : (
              ""
            )}
            <TableView
              dataTable={FieldOfficer?.pageData ?? []}
              currentPage={FieldOfficer?.page?.currentPage ?? 0}
              currentElement={FieldOfficer?.page?.currentElement ?? 10}
              totalCount={FieldOfficer?.page?.totalCount ?? 0}
              columnProperties={columnRegionalProperties}
              callbackAfterPageChange={changeRegionalsPage}
              loadingGetData={General?.loading}
              ignoreSinglePage
              rowClasses={() => {
                return "cursor-pointer"
              }}
            />
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )
}